export const statusOptions = [
  {
    label: "Pending ",
    color: "#E9A30C",
    value: "pending_approval"
  },
  {
    label: "Approved",
    color: "#3F9142",
    value: "approved"
  },
  {
    label: "Rejected",
    color: "#D93A3A",
    value: "rejected"
  }
];
